<template>
  <span v-if="totalPendente > 0" class="doc-check-badge d-inline-flex align-items-center gap-1 position-relative"
        style="font-size: 0.7rem; white-space: nowrap; user-select: none; cursor: pointer;">
    <i class="bi bi-exclamation-triangle-fill text-danger"></i>
    <span class="badge bg-danger rounded-pill env-badge-num">{{ totalPendente }}</span>

    <!-- Dropdown -->
    <div v-if="aberto" class="doc-check-dropdown" @click.stop>
      <div class="dropdown-header px-3 py-2 border-bottom">
        <strong class="text-danger small">
          <i class="bi bi-exclamation-triangle-fill me-1"></i>
          {{ totalPendente }} componentes sem documentação
        </strong>
      </div>
      <div class="dropdown-body px-3 py-2" style="max-height: 300px; overflow-y: auto;">
        <div v-for="(grupo, pasta) in porPasta" :key="pasta" class="grupo mb-2">
          <div class="pasta-nome fw-semibold text-body-secondary" style="font-size: 0.7rem;">
            📁 {{ pasta }}/
          </div>
          <div v-for="comp in grupo" :key="comp" class="componente ps-3" style="font-size: 0.7rem;">
            └ {{ comp }}.vue
          </div>
        </div>
        <div v-if="Object.keys(porPasta).length === 0" class="text-muted small">
          Nenhum componente pendente.
        </div>
      </div>
      <div class="dropdown-footer px-3 py-2 border-top d-flex align-items-center gap-2">
        <button class="btn btn-sm btn-outline-danger py-0 px-2" style="font-size: 0.7rem;" @click="verificar">
          <i class="bi bi-arrow-clockwise me-1"></i>Verificar
        </button>
        <button class="btn btn-sm btn-outline-secondary py-0 px-2" style="font-size: 0.7rem;" @click="copiar">
          <i class="bi bi-clipboard me-1"></i>Copiar
        </button>
        <span class="text-muted ms-auto" style="font-size: 0.65rem;">
          Última: {{ ultimaVerificacao }}
        </span>
      </div>
    </div>
  </span>
</template>

<script>
import api from '@/services/api'

function detectDevelopment () {
  const env = (process.env.VUE_APP_ENV || '').toLowerCase()
  if (env === 'development') return true

  const host = window.location.hostname
  if (host === 'localhost' || host === '127.0.0.1') return true

  return false
}

export default {
  name: 'DocCheckBadge',
  data () {
    return {
      totalPendente: 0,
      porPasta: {},
      semDocumentacao: [],
      aberto: false,
      ultimaVerificacao: '—',
      intervalId: null
    }
  },
  computed: {
    isDevelopment () {
      return detectDevelopment()
    }
  },
  mounted () {
    if (!this.isDevelopment) return
    this.verificar()
    this.intervalId = setInterval(() => this.verificar(), 30 * 60 * 1000) // 30min

    // Fecha dropdown ao clicar fora
    document.addEventListener('click', this.fecharDropdown)
  },
  beforeUnmount () {
    if (this.intervalId) clearInterval(this.intervalId)
    document.removeEventListener('click', this.fecharDropdown)
  },
  methods: {
    async verificar () {
      try {
        const response = await api.get('/Setup/verificar-componentes-sem-doc', {
          _suppressLoading: true
        })
        const data = response.data
        this.totalPendente = data.totalSemDocumentacao || 0
        this.porPasta = data.porPasta || {}
        this.semDocumentacao = data.semDocumentacao || []
        this.ultimaVerificacao = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      } catch {
        // Modo produção ou backend offline — silencioso
        this.totalPendente = 0
      }
    },
    toggleDropdown () {
      this.aberto = !this.aberto
    },
    fecharDropdown () {
      this.aberto = false
    },
    copiar () {
      const texto = this.semDocumentacao.join('\n')
      if (navigator.clipboard && texto) {
        navigator.clipboard.writeText(texto)
      }
      this.aberto = false
    }
  }
}
</script>

<style scoped>
.doc-check-badge {
  line-height: 1;
  opacity: 0.85;
  transition: opacity 0.2s ease;
}
.doc-check-badge:hover {
  opacity: 1;
}
.env-badge-num {
  font-size: 0.6rem;
  padding: 0.1em 0.4em;
  line-height: 1.2;
}
.doc-check-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 9999;
  min-width: 360px;
  max-width: 480px;
  margin-top: 6px;
  background-color: var(--bs-body-bg, #fff);
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  color: var(--bs-body-color, #212529);
}
.doc-check-dropdown .dropdown-header {
  background-color: var(--bs-tertiary-bg, #f8f9fa);
  border-radius: 6px 6px 0 0;
}
.doc-check-dropdown .dropdown-footer {
  background-color: var(--bs-tertiary-bg, #f8f9fa);
  border-radius: 0 0 6px 6px;
}
</style>
